import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=20f3fc3d&scoped=true&"
import script from "./breadcrumb.component.ts?vue&type=script&lang=ts&"
export * from "./breadcrumb.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f3fc3d",
  null
  
)

export default component.exports